module.exports = __webpack_public_path__ + "img/GCP.75abe10b.png";